import Swiper from 'swiper/bundle';

// sliders
window.Swiper = Swiper;

var sliderTop = new Swiper(".js-slider-partners", {
  slidesPerView: 1,
  spaceBetween: 20,
  autoHeight: true,
  navigation: {
    prevEl: ".js-slider-partners-prev",
    nextEl: ".js-slider-partners-next",
  },
  breakpoints: {
    992: {
      slidesPerView: "auto",
    },
  },
});